export const SHARE_DOC = "SHARE_DOC";